import { type Dispatch } from 'redux';
import { type OrderPricing, type Pricing } from '~shared/features/pricing/types';
import { get } from '~shared/helpers/apiHelper';
import { type APIError } from '~shared/types/APIError';

const API_VERSION_V4 = 'v4';

export const FETCH_PRESCRIPTION_PRICING_LOADING = 'FETCH_PRESCRIPTION_PRICING_LOADING';
export type ActionFetchingPrescriptionPricing = {
  type: typeof FETCH_PRESCRIPTION_PRICING_LOADING;
};
export function fetchingPrescriptionPricing(): ActionFetchingPrescriptionPricing {
  return {
    type: FETCH_PRESCRIPTION_PRICING_LOADING,
  };
}

export const FETCH_PRESCRIPTION_PRICING_SUCCEEDED = 'FETCH_PRESCRIPTION_PRICING_SUCCEEDED';
type FetchPrescriptionPricingSucceededPayload = { item_pricing: Pricing[] };
export type ActionFetchPrescriptionPricingSucceeded = {
  type: typeof FETCH_PRESCRIPTION_PRICING_SUCCEEDED;
  payload: FetchPrescriptionPricingSucceededPayload;
};

export function fetchPrescriptionPricingSucceeded(
  prescriptions: FetchPrescriptionPricingSucceededPayload,
): ActionFetchPrescriptionPricingSucceeded {
  return {
    type: FETCH_PRESCRIPTION_PRICING_SUCCEEDED,
    payload: prescriptions,
  };
}

export const FETCH_PRESCRIPTION_PRICING_FAILED = 'FETCH_PRESCRIPTION_PRICING_FAILED';
export type ActionFetchPrescriptionPricingFailed = {
  type: typeof FETCH_PRESCRIPTION_PRICING_FAILED;
  payload: APIError;
  error: true;
};
export function fetchPrescriptionPricingFailed(error: APIError): ActionFetchPrescriptionPricingFailed {
  return {
    type: FETCH_PRESCRIPTION_PRICING_FAILED,
    payload: error,
    error: true,
  };
}

export const FETCH_ORDER_PRICING_LOADING = 'FETCH_ORDER_PRICING_LOADING';
type ActionFetchingOrderPricing = {
  type: typeof FETCH_ORDER_PRICING_LOADING;
};
export function fetchingOrderPricing(): ActionFetchingOrderPricing {
  return {
    type: FETCH_ORDER_PRICING_LOADING,
  };
}

export type OrderPricingAPIResponse = Omit<OrderPricing, 'item_pricing' | 'shipment_id'> & { item_pricing: Pricing[] };

export const FETCH_ORDER_PRICING_SUCCEEDED = 'FETCH_ORDER_PRICING_SUCCEEDED';
type FetchOrderPricingSucceededPayload = OrderPricingAPIResponse & {
  isShipmentPricing: boolean;
  isEditPricing: boolean;
};
export type ActionFetchOrderPricingSucceeded = {
  type: typeof FETCH_ORDER_PRICING_SUCCEEDED;
  payload: FetchOrderPricingSucceededPayload;
};
export function fetchOrderPricingSucceeded(
  orderPricing: FetchOrderPricingSucceededPayload,
): ActionFetchOrderPricingSucceeded {
  return {
    type: FETCH_ORDER_PRICING_SUCCEEDED,
    payload: orderPricing,
  };
}

export const FETCH_ORDER_PRICING_FAILED = 'FETCH_ORDER_PRICING_FAILED';
export type ActionFetchOrderPricingFailed = {
  type: typeof FETCH_ORDER_PRICING_FAILED;
  payload: APIError;
  error: true;
};
export function fetchOrderPricingFailed(error: APIError): ActionFetchOrderPricingFailed {
  return {
    type: FETCH_ORDER_PRICING_FAILED,
    payload: error,
    error: true,
  };
}

type PrescriptionActions =
  | ActionFetchingPrescriptionPricing
  | ActionFetchPrescriptionPricingFailed
  | ActionFetchPrescriptionPricingSucceeded;

type OrderActions = ActionFetchingOrderPricing | ActionFetchOrderPricingFailed | ActionFetchOrderPricingSucceeded;

export type PricingActions = PrescriptionActions | OrderActions;

/**
 * @deprecated Redux networking action.
 * @see https://www.notion.so/alto/Guidebook-Migrating-Redux-Networking-Actions-To-React-Query-8567e05fc96c46fcb8020595f24b0edc
 */
export function fetchPrescriptionPricing() {
  return (dispatch: Dispatch<PrescriptionActions>) => {
    dispatch(fetchingPrescriptionPricing());
    return get('/pricing/prescriptions', {}, { version: API_VERSION_V4 }).then((json) => {
      if (json.error) {
        dispatch(fetchPrescriptionPricingFailed(json.error));
        return false;
      }

      dispatch(fetchPrescriptionPricingSucceeded(json));
      return true;
    });
  };
}
